const ProductSolutionCard = (props) => {
    const handleOnClick = () => {
        if (window.location.href.includes("solution")) {
            window.location.href = `/business/solution-detail?id=${props.id}`;
        } else {
            window.location.href = `/business/product-detail?id=${props.id}`;
        }
    };
    return (
        <>
            <div
                className="w-[400px] h-[270px] flex flex-col mb-[20px] mr-[5px] justify-center items-center text-[20px] hover:bg-stone-300 "
                onClick={() => handleOnClick()}
            >
                <img className="w-[390px] h-[200px] mb-[10px] border-solid border-[1px]" style={{objectFit:"contain"}} src={props.image} />
                {props.name}
            </div>
        </>
    );
};
export default ProductSolutionCard;
